// @flow
/** @jsx jsx */

import { jsx } from '@emotion/core';
import { usePrevious } from '@zapier/common-hooks';

import MaybeRedirectCreator from 'app/common/components/MaybeRedirectCreator';

import type { Element } from 'react';

type Props = {
  Component: Element<>,
  redirectUrl: string,
  shouldRedirect: boolean,
  onRedirect: (url: string) => void,
};

function MaybeRedirectOnMount(props: Props) {
  const {
    Component,
    onRedirect,
    redirectUrl,
    shouldRedirect,
    ...restProps
  } = props;

  const prevShouldRedirect = usePrevious(shouldRedirect);

  if (!prevShouldRedirect && shouldRedirect) {
    onRedirect(redirectUrl);
  }

  return !shouldRedirect && <Component {...restProps} />;
}

export default MaybeRedirectCreator(MaybeRedirectOnMount);
